export default __webpack_public_path__ + "static/media/638.42b87352.jpg";